import { styled } from 'styled-components';
import { StyledLabel } from '../Label';
export const CheckboxContainer = styled.label `
  display: inline-flex;
  gap: 8px;
  position: relative;

  & ${StyledLabel} {
    color: ${({ theme: { colors }, disabled }) => (disabled ? colors.grey100_2 : colors.black_1)};
    margin: 0;
  }
`;
const Icon = styled.svg `
  visibility: hidden;

  rect {
    fill: ${({ theme }) => theme.colors.main};
  }

  polyline {
    fill: none;
    stroke: ${({ theme }) => theme.colors.main};
    stroke-width: 4px;
  }
`;
export const CheckboxWrapper = styled.div `
  position: relative;
  width: 20px;
  height: 20px;
`;
export const StyledCheckbox = styled.div `
  position: relative;
  z-index: 1;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  height: 100%;
  background-color: ${({ checked, $indeterminate, disabled, theme: { colors } }) => {
    if (disabled)
        return checked || $indeterminate ? colors.grey30_2 : colors.grey05_3;
    return checked || $indeterminate ? colors.main : colors.grey00_1;
}};
  border: 1px solid
    ${({ checked, $indeterminate, disabled, theme: { colors } }) => {
    if (disabled)
        return colors.grey30_2;
    return checked || $indeterminate ? colors.main : colors.grey70_1;
}};
  border-radius: 4px;
  transition: all 100ms;

  & svg {
    position: absolute;
  }
`;
export const HiddenCheckbox = styled.input `
  position: absolute;
  border: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  z-index: 1;
  opacity: 0;
  background: none;

  &:indeterminate + ${StyledCheckbox}, &:checked + ${StyledCheckbox} {
    ${Icon} {
      visibility: visible;
    }
  }

  &:indeterminate:not(:disabled):hover + ${StyledCheckbox}, &:checked:not(:disabled):hover + ${StyledCheckbox} {
    background-color: ${({ theme }) => theme.colors.mainDark};
    border-color: ${({ theme }) => theme.colors.mainDark};
  }

  &:not(:indeterminate):not(:checked):not(:disabled):hover + ${StyledCheckbox} {
    border-color: ${({ theme }) => theme.colors.grey100_1};
  }

  &:focus-visible,
  &:focus {
    & + ${StyledCheckbox} {
      outline: none;
      ${({ theme }) => theme.shadows.focus}
    }
  }
`;
